// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   BrainPage – Uses design system from colors.css
   ============================================================ */

/* ── Root ──────────────────────────────────────────────── */
.bp {
  display: flex;
  height: 100vh;
  background: var(--color-bg-root);
  color: var(--color-text-primary);
  overflow: hidden;
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
}

/* ── Left: Brain Canvas ────────────────────────────────── */
.bp__left {
  flex: 1 1;
  position: relative;
  min-width: 0;
  background: var(--color-bg-canvas-frame);
}

.bp__page-logo {
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 25;
  display: flex;
  align-items: center;
  text-decoration: none;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.bp__page-logo:hover {
  opacity: 1;
}
.bp__page-logo-img {
  height: 72px;
  width: auto;
}

.bp__canvas {
  width: 100%;
  height: 100%;
  display: block;
  outline: none;
}

.bp__mesh-loading {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  z-index: 10;
  color: var(--color-text-secondary);
  font-size: 13px;
}

.bp__spinner {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid var(--color-border-input);
  border-top-color: var(--color-accent-base);
  animation: bp-spin 0.8s linear infinite;
}

@keyframes bp-spin {
  to { transform: rotate(360deg); }
}

/* ── Colorbar (top-right of brain area) ────────────────── */
.bp__colorbar {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 20;
}

.bp__colorbar-lo,
.bp__colorbar-hi {
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.3px;
  color: var(--color-text-secondary);
  opacity: 0.6;
}

.bp__colorbar-bar {
  width: 100px;
  height: 10px;
  border-radius: 3px;
  background: linear-gradient(
    to right,
    #1a0000,
    #800000,
    #d91a00,
    #ff6600,
    #ffbf33,
    #ffffb3
  );
  border: 1px solid var(--color-border-input);
}

.bp__colorbar-title {
  position: absolute;
  top: 36px;
  right: 20px;
  font-size: 9px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: var(--color-text-secondary);
  opacity: 0.5;
  width: 100px;
  text-align: center;
  margin-right: 26px;
}

/* ── Now-playing info (top-left of brain area) ─────────── */
.bp__now-info {
  position: absolute;
  top: 48px;
  left: 16px;
  z-index: 20;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 14px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
}

.bp__now-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.bp__now-stats {
  font-size: 11px;
  font-family: 'SF Mono', 'Fira Code', monospace;
  color: var(--color-text-secondary);
}

/* ── Bottom overlay (controls + engagement) ────────────── */
.bp__bottom-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  padding: 0 20px 14px;
  background: linear-gradient(to top, var(--color-bg-canvas-frame) 0%, rgba(0,0,0,0.5) 60%, transparent 100%);
  pointer-events: none;
}
.bp__bottom-overlay > * { pointer-events: auto; }

.bp__controls {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
}

.bp__ctrl-btn {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}
.bp__ctrl-btn:hover { background: var(--color-bg-user-bubble); color: var(--color-text-primary); }

.bp__ctrl-time {
  font-size: 11px;
  font-family: 'SF Mono', 'Fira Code', monospace;
  color: var(--color-text-secondary);
  min-width: 24px;
  text-align: center;
}

.bp__ctrl-slider {
  width: 180px;
  height: 4px;
  appearance: none;
  background: var(--color-border-input);
  border-radius: 2px;
  outline: none;
  cursor: pointer;
}
.bp__ctrl-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--color-text-secondary);
  cursor: pointer;
}
.bp__ctrl-slider::-moz-range-thumb {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--color-text-secondary);
  cursor: pointer;
  border: none;
}

.bp__ctrl-speed {
  font-size: 10px;
  font-family: 'SF Mono', 'Fira Code', monospace;
  padding: 3px 7px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: all 0.15s;
}
.bp__ctrl-speed:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.bp__ctrl-clear {
  width: 28px;
  height: 28px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}
.bp__ctrl-clear:hover {
  border-color: var(--color-status-error-border);
  color: var(--color-status-error-text);
}

/* ── Engagement ─────────────────────────────────────────── */
.bp__engagement {
  width: 100%;
  max-width: 640px;
  margin-top: 8px;
  padding: 14px 18px 10px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
}

.bp__eng-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.bp__eng-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: var(--color-text-secondary);
}

.bp__eng-scores {
  display: flex;
  gap: 24px;
}

.bp__eng-score {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.bp__eng-score-label {
  font-size: 12px;
  color: var(--color-text-secondary);
}

.bp__eng-score-value {
  font-size: 24px;
  font-weight: 700;
  font-family: 'SF Mono', 'Fira Code', monospace;
  color: var(--color-text-primary);
}

.bp__eng-score--high {
  color: var(--color-accent-strong);
}

.bp__eng-graph {
  width: 100%;
  height: 80px;
  display: block;
}

/* ── Right: Controls Panel ─────────────────────────────── */
.bp__right {
  width: 420px;
  min-width: 340px;
  border-left: 1px solid var(--color-border-input);
  background: var(--color-bg-sidebar);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.bp__right-scroll {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.bp__right-scroll::-webkit-scrollbar { width: 4px; }
.bp__right-scroll::-webkit-scrollbar-thumb {
  background: var(--color-scrollbar-thumb);
  border-radius: 2px;
}

/* Header */
.bp__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bp__logo-text {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
  letter-spacing: -0.2px;
}

.bp__badge {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: var(--color-text-secondary);
  padding: 4px 10px;
  border: 1px solid var(--color-border-input);
  border-radius: 999px;
}

/* Tabs */
.bp__tabs {
  display: flex;
  gap: 0;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  overflow: hidden;
}

.bp__tab {
  flex: 1 1;
  padding: 8px 16px;
  border: none;
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}
.bp__tab:hover { background: var(--color-bg-user-bubble); }
.bp__tab--active {
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
}
.bp__tab + .bp__tab {
  border-left: 1px solid var(--color-border-input);
}

/* Description */
.bp__desc {
  font-size: 13px;
  line-height: 1.6;
  color: var(--color-text-secondary);
  margin: 0;
}

/* Error */
.bp__error {
  padding: 10px 14px;
  background: var(--color-status-error-tint);
  border: 1px solid var(--color-status-error-border);
  border-radius: 6px;
  color: var(--color-status-error-text);
  font-size: 13px;
}

/* Processing */
.bp__processing {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px 0;
}

.bp__proc-bar {
  width: 100%;
  height: 3px;
  background: var(--color-border-input);
  border-radius: 2px;
  overflow: hidden;
}

.bp__proc-bar-fill {
  height: 100%;
  width: 40%;
  background: var(--color-accent-base);
  border-radius: 2px;
  animation: bp-proc-slide 1.8s ease-in-out infinite;
}
.bp__proc-bar-fill[style*="width"] {
  animation: none;
}

@keyframes bp-proc-slide {
  0%   { transform: translateX(-100%); }
  50%  { transform: translateX(150%); }
  100% { transform: translateX(-100%); }
}

.bp__proc-text {
  font-size: 13px;
  color: var(--color-text-secondary);
}
.bp__proc-text strong { color: var(--color-text-primary); }

.bp__proc-step {
  font-size: 11px;
  font-family: 'SF Mono', 'Fira Code', monospace;
  color: var(--color-text-secondary);
}

.bp__proc-eta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2px;
}

.bp__proc-eta-time {
  font-size: 13px;
  font-weight: 600;
  font-family: 'SF Mono', 'Fira Code', monospace;
  color: var(--color-text-primary);
}

.bp__proc-eta-hint {
  font-size: 11px;
  color: var(--color-text-secondary);
  opacity: 0.7;
}

/* ── Dropzone ──────────────────────────────────────────── */
.bp__dropzone {
  padding: 28px 24px;
  border: 1px dashed var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-canvas-surface);
  cursor: pointer;
  transition: all 0.15s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: var(--color-text-secondary);
  font-size: 13px;
}
.bp__dropzone:hover {
  border-color: var(--color-text-secondary);
  background: var(--color-bg-user-bubble);
}
.bp__dropzone--active {
  border-color: var(--color-text-secondary);
}
.bp__dropzone u { color: var(--color-text-primary); }

.bp__drop-hint {
  font-size: 11px;
  color: var(--color-text-secondary);
  opacity: 0.6;
}

/* ── Text input ────────────────────────────────────────── */
.bp__text-area {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.bp__textarea {
  width: 100%;
  min-height: 100px;
  padding: 12px 14px;
  border-radius: 6px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 14px;
  font-family: inherit;
  line-height: 1.6;
  resize: vertical;
  outline: none;
  transition: border-color 0.15s;
  box-sizing: border-box;
}
.bp__textarea::placeholder { color: var(--color-text-secondary); }
.bp__textarea:focus { border-color: var(--color-text-secondary); }

.bp__text-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bp__char-count {
  font-size: 11px;
  font-family: 'SF Mono', 'Fira Code', monospace;
  color: var(--color-text-secondary);
  opacity: 0.6;
}

.bp__analyze-btn {
  padding: 8px 18px;
  border-radius: 4px;
  border: none;
  background: var(--color-accent-base);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s;
}
.bp__analyze-btn:hover:not(:disabled) { opacity: 0.85; }
.bp__analyze-btn:disabled { opacity: 0.3; cursor: default; }

/* ── Examples ──────────────────────────────────────────── */
.bp__examples-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.bp__examples-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: var(--color-text-secondary);
  opacity: 0.6;
}

.bp__examples-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
}
.bp__examples-grid--text {
  grid-template-columns: 1fr;
}

/* Video example card */
.bp__example-card {
  position: relative;
  aspect-ratio: 16 / 10;
  border-radius: 6px;
  border: 1px solid var(--color-border-input);
  cursor: pointer;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  padding: 0;
}
.bp__example-card:hover {
  border-color: var(--color-text-secondary);
}

.bp__example-name {
  font-size: 10px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
}

.bp__example-desc {
  font-size: 9px;
  color: rgba(255, 255, 255, 0.45);
}

/* Text example card */
.bp__example-text-card {
  padding: 12px 14px;
  border-radius: 6px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  cursor: pointer;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 4px;
  transition: all 0.15s;
}
.bp__example-text-card:hover {
  border-color: var(--color-text-secondary);
  background: var(--color-bg-user-bubble);
}

.bp__example-text-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.bp__example-text-preview {
  font-size: 12px;
  line-height: 1.5;
  color: var(--color-text-secondary);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* ── Video player (right panel) ────────────────────────── */
.bp__video-wrap {
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid var(--color-border-input);
  background: #000;
}

.bp__video {
  width: 100%;
  display: block;
  aspect-ratio: 16 / 9;
  object-fit: contain;
  background: #000;
}

.bp__video-time {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 24px 12px 8px;
  background: linear-gradient(to top, rgba(0,0,0,0.6), transparent);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.bp__video-ts {
  font-family: 'SF Mono', 'Fira Code', monospace;
  color: rgba(255, 255, 255, 0.45);
  font-size: 11px;
}

/* Video example placeholder */
.bp__video-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 40px 24px;
  border-radius: 6px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-secondary);
}

.bp__video-placeholder-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.bp__video-placeholder-ts {
  font-size: 12px;
  font-family: 'SF Mono', 'Fira Code', monospace;
  color: var(--color-text-secondary);
}

/* ── Text display with highlighting ────────────────────── */
.bp__text-display {
  border-radius: 6px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  overflow: hidden;
}

.bp__text-display-label {
  padding: 10px 14px 0;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: var(--color-text-secondary);
}

.bp__text-display-body {
  padding: 10px 14px 14px;
  font-size: 14px;
  line-height: 1.8;
  max-height: 280px;
  overflow-y: auto;
}
.bp__text-display-body::-webkit-scrollbar { width: 4px; }
.bp__text-display-body::-webkit-scrollbar-thumb {
  background: var(--color-scrollbar-thumb);
  border-radius: 2px;
}

.bp__tw--active {
  color: var(--color-text-primary);
  background: color-mix(in srgb, var(--color-accent-base) 20%, transparent);
  border-radius: 3px;
  padding: 2px 4px;
  margin: -2px -4px;
  transition: background 0.15s;
}

.bp__tw--dim {
  color: var(--color-text-secondary);
  opacity: 0.5;
  transition: color 0.15s;
}

/* ── New Analysis button ───────────────────────────────── */
.bp__new-analysis-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  align-self: flex-start;
}
.bp__new-analysis-btn:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

/* ── Footer ────────────────────────────────────────────── */
.bp__footer {
  margin-top: auto;
  padding-top: 16px;
  font-size: 11px;
  color: var(--color-text-secondary);
  opacity: 0.5;
}
.bp__footer a {
  color: var(--color-text-secondary);
  text-decoration: none;
  border-bottom: 1px solid var(--color-border-input);
}
.bp__footer a:hover { color: var(--color-text-primary); }

/* ── UGC Promo Card ───────────────────────────────────── */
.bp__promo {
  margin-top: auto;
  border-radius: 8px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  overflow: hidden;
  position: relative;
  transition: border-color 0.2s;
}
.bp__promo:hover {
  border-color: color-mix(in srgb, var(--color-accent-base) 50%, var(--color-border-input));
}
.bp__promo::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, var(--color-accent-base, #d98f4f), var(--color-accent-strong, #e3a36a), var(--color-accent-base, #d98f4f), transparent);
  z-index: 1;
}

.bp__promo-visual {
  position: relative;
  height: 100px;
  background: linear-gradient(160deg, rgba(217,143,79,0.07) 0%, rgba(217,143,79,0.02) 100%);
  overflow: hidden;
}

.bp__promo-chart-svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.bp__promo-platforms {
  position: absolute;
  top: 12px;
  left: 14px;
  display: flex;
  gap: 8px;
}

.bp__promo-platform {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-secondary);
  animation: bp-promo-float 3s ease-in-out infinite;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}
.bp__promo-platform--2 { animation-delay: 0.6s; }
.bp__promo-platform--3 { animation-delay: 1.2s; }

@keyframes bp-promo-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-3px); }
}

.bp__promo-stats {
  position: absolute;
  bottom: 10px;
  right: 14px;
  display: flex;
  gap: 16px;
}

.bp__promo-stat {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1px;
}

.bp__promo-stat-val {
  font-size: 14px;
  font-weight: 700;
  font-family: 'SF Mono', 'Fira Code', monospace;
  color: var(--color-accent-base, #d98f4f);
}

.bp__promo-stat-lbl {
  font-size: 9px;
  color: var(--color-text-secondary);
  opacity: 0.6;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.bp__promo-body {
  padding: 14px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.bp__promo-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.bp__promo-logo {
  height: 16px;
  width: auto;
  opacity: 0.85;
}

.bp__promo-label {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: var(--color-accent-base, #d98f4f);
}

.bp__promo-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
  line-height: 1.35;
  margin: 0;
}

.bp__promo-desc {
  font-size: 12px;
  line-height: 1.55;
  color: var(--color-text-secondary);
  margin: 0;
}

.bp__promo-cta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  padding: 8px 16px;
  border-radius: 5px;
  background: var(--color-accent-base, #d98f4f);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  transition: opacity 0.15s, transform 0.15s;
  align-self: flex-start;
}
.bp__promo-cta:hover {
  opacity: 0.88;
  transform: translateX(2px);
}

/* ── Onboarding Modal ──────────────────────────────────── */
.bp-ob {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  animation: bp-ob-fadeIn 0.3s ease;
}

@keyframes bp-ob-fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.bp-ob__card {
  position: relative;
  width: 480px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 48px);
  border-radius: 14px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-sidebar);
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.04),
    0 24px 80px rgba(0, 0, 0, 0.55),
    0 4px 16px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: bp-ob-slideUp 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes bp-ob-slideUp {
  from { opacity: 0; transform: translateY(24px) scale(0.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.bp-ob__close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  border: none;
  background: rgba(0, 0, 0, 0.3);
  color: var(--color-text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, color 0.15s;
}
.bp-ob__close:hover {
  background: rgba(255, 255, 255, 0.1);
  color: var(--color-text-primary);
}

/* Visuals area */
.bp-ob__visual {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.bp-ob__visual--welcome {
  height: 200px;
  background: radial-gradient(ellipse at 50% 80%, rgba(217,143,79,0.08) 0%, transparent 70%),
              var(--color-bg-canvas-frame);
}

.bp-ob__visual--pipeline {
  height: 180px;
  padding: 0 24px;
  background: radial-gradient(ellipse at 50% 50%, rgba(217,143,79,0.06) 0%, transparent 70%),
              var(--color-bg-canvas-frame);
}

.bp-ob__visual--results {
  height: 170px;
  padding: 20px 24px;
  background: radial-gradient(ellipse at 50% 50%, rgba(217,143,79,0.06) 0%, transparent 70%),
              var(--color-bg-canvas-frame);
}

.bp-ob__hero-svg {
  width: 320px;
  height: 180px;
}

/* Pulse animation for brain hotspots */
@keyframes bp-ob-pulse {
  0%, 100% { r: 14; opacity: 0.7; }
  50% { r: 18; opacity: 0.45; }
}
@keyframes bp-ob-pulse-sm {
  0%, 100% { r: 10; opacity: 0.55; }
  50% { r: 13; opacity: 0.35; }
}

.bp-ob__pulse {
  animation: bp-ob-pulse 2.5s ease-in-out infinite;
}
.bp-ob__pulse--d1 {
  animation: bp-ob-pulse-sm 2.5s ease-in-out 0.4s infinite;
}
.bp-ob__pulse--d2 {
  animation: bp-ob-pulse-sm 2.5s ease-in-out 0.8s infinite;
}
.bp-ob__pulse--d3 {
  animation: bp-ob-pulse-sm 2.5s ease-in-out 1.2s infinite;
}

/* Pipeline step visual */
.bp-ob__pipeline {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
}

.bp-ob__pipe-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
}

.bp-ob__pipe-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-secondary);
  transition: all 0.3s;
}

.bp-ob__pipe-icon--accent {
  border-color: color-mix(in srgb, var(--color-accent-base) 40%, var(--color-border-input));
  color: var(--color-accent-base, #d98f4f);
  box-shadow: 0 0 20px rgba(217, 143, 79, 0.1);
}

.bp-ob__pipe-icon--glow {
  border-color: color-mix(in srgb, var(--color-accent-base) 50%, var(--color-border-input));
  color: var(--color-accent-strong, #e3a36a);
  box-shadow: 0 0 24px rgba(217, 143, 79, 0.15);
  background: linear-gradient(135deg, var(--color-bg-canvas-surface), color-mix(in srgb, var(--color-accent-base) 8%, var(--color-bg-canvas-surface)));
}

.bp-ob__pipe-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-primary);
  white-space: nowrap;
}

.bp-ob__pipe-sub {
  font-size: 9px;
  color: var(--color-text-secondary);
  opacity: 0.65;
  white-space: nowrap;
  text-align: center;
  max-width: 100px;
}

.bp-ob__pipe-arrow {
  flex-shrink: 0;
  opacity: 0.5;
  margin-bottom: 24px;
}

/* Results grid */
.bp-ob__results-row {
  display: flex;
  gap: 12px;
  width: 100%;
}

.bp-ob__result-card {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 14px 8px 10px;
  border-radius: 10px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
}

.bp-ob__result-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
}

.bp-ob__result-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-primary);
  text-align: center;
}

.bp-ob__result-hint {
  font-size: 9px;
  color: var(--color-text-secondary);
  opacity: 0.6;
  text-align: center;
}

/* Content */
.bp-ob__content {
  padding: 20px 28px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.bp-ob__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--color-text-primary);
  letter-spacing: -0.3px;
}

.bp-ob__body {
  margin: 0;
  font-size: 13px;
  line-height: 1.65;
  color: var(--color-text-secondary);
}

/* Footer */
.bp-ob__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 28px 20px;
}

.bp-ob__dots {
  display: flex;
  gap: 6px;
}

.bp-ob__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  border: none;
  padding: 0;
  background: var(--color-border-input);
  cursor: pointer;
  transition: all 0.2s;
}
.bp-ob__dot--active {
  background: var(--color-accent-base, #d98f4f);
  box-shadow: 0 0 6px rgba(217, 143, 79, 0.4);
  transform: scale(1.15);
}
.bp-ob__dot:hover:not(.bp-ob__dot--active) {
  background: var(--color-text-secondary);
}

.bp-ob__actions {
  display: flex;
  gap: 8px;
}

.bp-ob__btn {
  padding: 8px 20px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  border: none;
}

.bp-ob__btn--primary {
  background: var(--color-accent-base, #d98f4f);
  color: #fff;
}
.bp-ob__btn--primary:hover {
  opacity: 0.88;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(217, 143, 79, 0.3);
}

.bp-ob__btn--ghost {
  background: transparent;
  color: var(--color-text-secondary);
  border: 1px solid var(--color-border-input);
}
.bp-ob__btn--ghost:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

/* ── Responsive ────────────────────────────────────────── */
@media (max-width: 900px) {
  .bp {
    flex-direction: column;
  }
  .bp__left {
    height: 45vh;
    min-height: 300px;
  }
  .bp__right {
    width: 100%;
    min-width: 0;
    border-left: none;
    border-top: 1px solid var(--color-border-input);
  }
  .bp__examples-grid {
    grid-template-columns: 1fr 1fr;
  }
  .bp__ctrl-slider {
    width: 120px;
  }
  .bp__promo-visual {
    height: 80px;
  }
  .bp__promo-stats {
    gap: 10px;
  }
}

@media (max-width: 500px) {
  .bp__right-scroll {
    padding: 16px 14px;
  }
  .bp__examples-grid {
    grid-template-columns: 1fr 1fr;
    gap: 6px;
  }
  .bp__now-info {
    display: none;
  }
  .bp-ob__card {
    border-radius: 10px;
  }
  .bp-ob__content {
    padding: 16px 20px 0;
  }
  .bp-ob__footer {
    padding: 14px 20px 16px;
  }
  .bp-ob__visual--welcome,
  .bp-ob__visual--pipeline,
  .bp-ob__visual--results {
    height: 150px;
  }
  .bp-ob__pipe-sub {
    display: none;
  }
  .bp-ob__result-hint {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/BrainPage.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE,6DAA6D;AAC7D;EACE,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;EAChB,8EAA8E;AAChF;;AAEA,6DAA6D;AAC7D;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB;;;;;;;;GAQC;EACD,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,kCAAkC;AACpC;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,MAAM;EACN,oBAAoB;EACpB,2GAA2G;EAC3G,oBAAoB;AACtB;AACA,0BAA0B,oBAAoB,EAAE;;AAEhD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA,sBAAsB,uCAAuC,EAAE,gCAAgC,EAAE;;AAEjG;EACE,eAAe;EACf,8CAA8C;EAC9C,kCAAkC;EAClC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EAEX,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,8CAA8C;EAC9C,qCAAqC;AACvC;;AAEA,8DAA8D;AAC9D;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,YAAY;EACZ,gBAAgB;EAChB,gDAAgD;EAChD,mCAAmC;EACnC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA,uCAAuC,UAAU,EAAE;AACnD;EACE,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kCAAkC;EAClC,iBAAiB;EACjB,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,MAAM;EACN,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA,iBAAiB,uCAAuC,EAAE;AAC1D;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;AACA;EACE,gDAAgD;AAClD;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,SAAS;AACX;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,kDAAkD;EAClD,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,oCAAoC;EACpC,kBAAkB;EAClB,kDAAkD;AACpD;AACA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;AACA,wBAAwB,gCAAgC,EAAE;;AAE1D;EACE,eAAe;EACf,8CAA8C;EAC9C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,YAAY;AACd;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,yCAAyC;EACzC,uCAAuC;AACzC;AACA;EACE,yCAAyC;AAC3C;AACA,kBAAkB,gCAAgC,EAAE;;AAEpD;EACE,eAAe;EACf,kCAAkC;EAClC,YAAY;AACd;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;AACA,6BAA6B,kCAAkC,EAAE;AACjE,sBAAsB,yCAAyC,EAAE;;AAEjE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA,wCAAwC,aAAa,EAAE;AACvD,4BAA4B,YAAY,EAAE,eAAe,EAAE;;AAE3D,6DAA6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,QAAQ;AACV;AACA;EACE,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;AACvB;AACA;EACE,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,iEAAiE;EACjE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,kCAAkC;AACpC;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA,4CAA4C,UAAU,EAAE;AACxD;EACE,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,yEAAyE;EACzE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,uBAAuB;AACzB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA,6DAA6D;AAC7D;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,kDAAkD;AACpD;AACA,sBAAsB,gCAAgC,EAAE;;AAExD,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,yFAAyF;AAC3F;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uKAAuK;EACvK,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yFAAyF;EACzF,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,iDAAiD;EACjD,sCAAsC;AACxC;AACA,yBAAyB,qBAAqB,EAAE;AAChD,yBAAyB,qBAAqB,EAAE;;AAEhD;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,6CAA6C;EAC7C,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,0CAA0C;EAC1C,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA,6DAA6D;AAC7D;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;EACnB,2CAA2C;EAC3C,mCAAmC;EACnC;;;iCAG+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb;0CACwC;AAC1C;;AAEA;EACE,aAAa;EACb,eAAe;EACf;0CACwC;AAC1C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB;0CACwC;AAC1C;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,uCAAuC;AACvC;EACE,WAAW,KAAK,EAAE,YAAY,EAAE;EAChC,MAAM,KAAK,EAAE,aAAa,EAAE;AAC9B;AACA;EACE,WAAW,KAAK,EAAE,aAAa,EAAE;EACjC,MAAM,KAAK,EAAE,aAAa,EAAE;AAC9B;;AAEA;EACE,gDAAgD;AAClD;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,wDAAwD;AAC1D;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,yFAAyF;EACzF,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,yFAAyF;EACzF,0CAA0C;EAC1C,6CAA6C;EAC7C,oJAAoJ;AACtJ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,qCAAqC;EACrC,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,6CAA6C;EAC7C,2CAA2C;EAC3C,sBAAsB;AACxB;AACA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,WAAW;AACb;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,2CAA2C;AAC7C;AACA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA,6DAA6D;AAC7D;EACE;IACE,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+CAA+C;EACjD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,8BAA8B;IAC9B,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;;;IAGE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ============================================================\n   BrainPage – Uses design system from colors.css\n   ============================================================ */\n\n/* ── Root ──────────────────────────────────────────────── */\n.bp {\n  display: flex;\n  height: 100vh;\n  background: var(--color-bg-root);\n  color: var(--color-text-primary);\n  overflow: hidden;\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n}\n\n/* ── Left: Brain Canvas ────────────────────────────────── */\n.bp__left {\n  flex: 1;\n  position: relative;\n  min-width: 0;\n  background: var(--color-bg-canvas-frame);\n}\n\n.bp__page-logo {\n  position: absolute;\n  top: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 25;\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n}\n.bp__page-logo:hover {\n  opacity: 1;\n}\n.bp__page-logo-img {\n  height: 72px;\n  width: auto;\n}\n\n.bp__canvas {\n  width: 100%;\n  height: 100%;\n  display: block;\n  outline: none;\n}\n\n.bp__mesh-loading {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  z-index: 10;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n}\n\n.bp__spinner {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 2px solid var(--color-border-input);\n  border-top-color: var(--color-accent-base);\n  animation: bp-spin 0.8s linear infinite;\n}\n\n@keyframes bp-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ── Colorbar (top-right of brain area) ────────────────── */\n.bp__colorbar {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  z-index: 20;\n}\n\n.bp__colorbar-lo,\n.bp__colorbar-hi {\n  font-size: 10px;\n  font-weight: 500;\n  letter-spacing: 0.3px;\n  color: var(--color-text-secondary);\n  opacity: 0.6;\n}\n\n.bp__colorbar-bar {\n  width: 100px;\n  height: 10px;\n  border-radius: 3px;\n  background: linear-gradient(\n    to right,\n    #1a0000,\n    #800000,\n    #d91a00,\n    #ff6600,\n    #ffbf33,\n    #ffffb3\n  );\n  border: 1px solid var(--color-border-input);\n}\n\n.bp__colorbar-title {\n  position: absolute;\n  top: 36px;\n  right: 20px;\n  font-size: 9px;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  color: var(--color-text-secondary);\n  opacity: 0.5;\n  width: 100px;\n  text-align: center;\n  margin-right: 26px;\n}\n\n/* ── Now-playing info (top-left of brain area) ─────────── */\n.bp__now-info {\n  position: absolute;\n  top: 48px;\n  left: 16px;\n  z-index: 20;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 10px 14px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n}\n\n.bp__now-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.bp__now-stats {\n  font-size: 11px;\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  color: var(--color-text-secondary);\n}\n\n/* ── Bottom overlay (controls + engagement) ────────────── */\n.bp__bottom-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 20;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0;\n  padding: 0 20px 14px;\n  background: linear-gradient(to top, var(--color-bg-canvas-frame) 0%, rgba(0,0,0,0.5) 60%, transparent 100%);\n  pointer-events: none;\n}\n.bp__bottom-overlay > * { pointer-events: auto; }\n\n.bp__controls {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 14px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n}\n\n.bp__ctrl-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s;\n}\n.bp__ctrl-btn:hover { background: var(--color-bg-user-bubble); color: var(--color-text-primary); }\n\n.bp__ctrl-time {\n  font-size: 11px;\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  color: var(--color-text-secondary);\n  min-width: 24px;\n  text-align: center;\n}\n\n.bp__ctrl-slider {\n  width: 180px;\n  height: 4px;\n  -webkit-appearance: none;\n  appearance: none;\n  background: var(--color-border-input);\n  border-radius: 2px;\n  outline: none;\n  cursor: pointer;\n}\n.bp__ctrl-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: var(--color-text-secondary);\n  cursor: pointer;\n}\n.bp__ctrl-slider::-moz-range-thumb {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: var(--color-text-secondary);\n  cursor: pointer;\n  border: none;\n}\n\n.bp__ctrl-speed {\n  font-size: 10px;\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  padding: 3px 7px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.bp__ctrl-speed:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.bp__ctrl-clear {\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n.bp__ctrl-clear:hover {\n  border-color: var(--color-status-error-border);\n  color: var(--color-status-error-text);\n}\n\n/* ── Engagement ─────────────────────────────────────────── */\n.bp__engagement {\n  width: 100%;\n  max-width: 640px;\n  margin-top: 8px;\n  padding: 14px 18px 10px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n}\n\n.bp__eng-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.bp__eng-title {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  color: var(--color-text-secondary);\n}\n\n.bp__eng-scores {\n  display: flex;\n  gap: 24px;\n}\n\n.bp__eng-score {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.bp__eng-score-label {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n.bp__eng-score-value {\n  font-size: 24px;\n  font-weight: 700;\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  color: var(--color-text-primary);\n}\n\n.bp__eng-score--high {\n  color: var(--color-accent-strong);\n}\n\n.bp__eng-graph {\n  width: 100%;\n  height: 80px;\n  display: block;\n}\n\n/* ── Right: Controls Panel ─────────────────────────────── */\n.bp__right {\n  width: 420px;\n  min-width: 340px;\n  border-left: 1px solid var(--color-border-input);\n  background: var(--color-bg-sidebar);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.bp__right-scroll {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px 20px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.bp__right-scroll::-webkit-scrollbar { width: 4px; }\n.bp__right-scroll::-webkit-scrollbar-thumb {\n  background: var(--color-scrollbar-thumb);\n  border-radius: 2px;\n}\n\n/* Header */\n.bp__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.bp__logo-text {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  letter-spacing: -0.2px;\n}\n\n.bp__badge {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  color: var(--color-text-secondary);\n  padding: 4px 10px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 999px;\n}\n\n/* Tabs */\n.bp__tabs {\n  display: flex;\n  gap: 0;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.bp__tab {\n  flex: 1;\n  padding: 8px 16px;\n  border: none;\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.bp__tab:hover { background: var(--color-bg-user-bubble); }\n.bp__tab--active {\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n}\n.bp__tab + .bp__tab {\n  border-left: 1px solid var(--color-border-input);\n}\n\n/* Description */\n.bp__desc {\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n/* Error */\n.bp__error {\n  padding: 10px 14px;\n  background: var(--color-status-error-tint);\n  border: 1px solid var(--color-status-error-border);\n  border-radius: 6px;\n  color: var(--color-status-error-text);\n  font-size: 13px;\n}\n\n/* Processing */\n.bp__processing {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 20px 0;\n}\n\n.bp__proc-bar {\n  width: 100%;\n  height: 3px;\n  background: var(--color-border-input);\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.bp__proc-bar-fill {\n  height: 100%;\n  width: 40%;\n  background: var(--color-accent-base);\n  border-radius: 2px;\n  animation: bp-proc-slide 1.8s ease-in-out infinite;\n}\n.bp__proc-bar-fill[style*=\"width\"] {\n  animation: none;\n}\n\n@keyframes bp-proc-slide {\n  0%   { transform: translateX(-100%); }\n  50%  { transform: translateX(150%); }\n  100% { transform: translateX(-100%); }\n}\n\n.bp__proc-text {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n}\n.bp__proc-text strong { color: var(--color-text-primary); }\n\n.bp__proc-step {\n  font-size: 11px;\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  color: var(--color-text-secondary);\n}\n\n.bp__proc-eta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 2px;\n}\n\n.bp__proc-eta-time {\n  font-size: 13px;\n  font-weight: 600;\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  color: var(--color-text-primary);\n}\n\n.bp__proc-eta-hint {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  opacity: 0.7;\n}\n\n/* ── Dropzone ──────────────────────────────────────────── */\n.bp__dropzone {\n  padding: 28px 24px;\n  border: 1px dashed var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-canvas-surface);\n  cursor: pointer;\n  transition: all 0.15s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n}\n.bp__dropzone:hover {\n  border-color: var(--color-text-secondary);\n  background: var(--color-bg-user-bubble);\n}\n.bp__dropzone--active {\n  border-color: var(--color-text-secondary);\n}\n.bp__dropzone u { color: var(--color-text-primary); }\n\n.bp__drop-hint {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  opacity: 0.6;\n}\n\n/* ── Text input ────────────────────────────────────────── */\n.bp__text-area {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.bp__textarea {\n  width: 100%;\n  min-height: 100px;\n  padding: 12px 14px;\n  border-radius: 6px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 14px;\n  font-family: inherit;\n  line-height: 1.6;\n  resize: vertical;\n  outline: none;\n  transition: border-color 0.15s;\n  box-sizing: border-box;\n}\n.bp__textarea::placeholder { color: var(--color-text-secondary); }\n.bp__textarea:focus { border-color: var(--color-text-secondary); }\n\n.bp__text-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.bp__char-count {\n  font-size: 11px;\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  color: var(--color-text-secondary);\n  opacity: 0.6;\n}\n\n.bp__analyze-btn {\n  padding: 8px 18px;\n  border-radius: 4px;\n  border: none;\n  background: var(--color-accent-base);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.15s;\n}\n.bp__analyze-btn:hover:not(:disabled) { opacity: 0.85; }\n.bp__analyze-btn:disabled { opacity: 0.3; cursor: default; }\n\n/* ── Examples ──────────────────────────────────────────── */\n.bp__examples-section {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.bp__examples-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  color: var(--color-text-secondary);\n  opacity: 0.6;\n}\n\n.bp__examples-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 8px;\n}\n.bp__examples-grid--text {\n  grid-template-columns: 1fr;\n}\n\n/* Video example card */\n.bp__example-card {\n  position: relative;\n  aspect-ratio: 16 / 10;\n  border-radius: 6px;\n  border: 1px solid var(--color-border-input);\n  cursor: pointer;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n  padding: 0;\n}\n.bp__example-card:hover {\n  border-color: var(--color-text-secondary);\n}\n\n.bp__example-name {\n  font-size: 10px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.bp__example-desc {\n  font-size: 9px;\n  color: rgba(255, 255, 255, 0.45);\n}\n\n/* Text example card */\n.bp__example-text-card {\n  padding: 12px 14px;\n  border-radius: 6px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  cursor: pointer;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  transition: all 0.15s;\n}\n.bp__example-text-card:hover {\n  border-color: var(--color-text-secondary);\n  background: var(--color-bg-user-bubble);\n}\n\n.bp__example-text-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.bp__example-text-preview {\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--color-text-secondary);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* ── Video player (right panel) ────────────────────────── */\n.bp__video-wrap {\n  position: relative;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid var(--color-border-input);\n  background: #000;\n}\n\n.bp__video {\n  width: 100%;\n  display: block;\n  aspect-ratio: 16 / 9;\n  object-fit: contain;\n  background: #000;\n}\n\n.bp__video-time {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 24px 12px 8px;\n  background: linear-gradient(to top, rgba(0,0,0,0.6), transparent);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.bp__video-ts {\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  color: rgba(255, 255, 255, 0.45);\n  font-size: 11px;\n}\n\n/* Video example placeholder */\n.bp__video-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 40px 24px;\n  border-radius: 6px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-secondary);\n}\n\n.bp__video-placeholder-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.bp__video-placeholder-ts {\n  font-size: 12px;\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  color: var(--color-text-secondary);\n}\n\n/* ── Text display with highlighting ────────────────────── */\n.bp__text-display {\n  border-radius: 6px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  overflow: hidden;\n}\n\n.bp__text-display-label {\n  padding: 10px 14px 0;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  color: var(--color-text-secondary);\n}\n\n.bp__text-display-body {\n  padding: 10px 14px 14px;\n  font-size: 14px;\n  line-height: 1.8;\n  max-height: 280px;\n  overflow-y: auto;\n}\n.bp__text-display-body::-webkit-scrollbar { width: 4px; }\n.bp__text-display-body::-webkit-scrollbar-thumb {\n  background: var(--color-scrollbar-thumb);\n  border-radius: 2px;\n}\n\n.bp__tw--active {\n  color: var(--color-text-primary);\n  background: color-mix(in srgb, var(--color-accent-base) 20%, transparent);\n  border-radius: 3px;\n  padding: 2px 4px;\n  margin: -2px -4px;\n  transition: background 0.15s;\n}\n\n.bp__tw--dim {\n  color: var(--color-text-secondary);\n  opacity: 0.5;\n  transition: color 0.15s;\n}\n\n/* ── New Analysis button ───────────────────────────────── */\n.bp__new-analysis-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n  align-self: flex-start;\n}\n.bp__new-analysis-btn:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n/* ── Footer ────────────────────────────────────────────── */\n.bp__footer {\n  margin-top: auto;\n  padding-top: 16px;\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  opacity: 0.5;\n}\n.bp__footer a {\n  color: var(--color-text-secondary);\n  text-decoration: none;\n  border-bottom: 1px solid var(--color-border-input);\n}\n.bp__footer a:hover { color: var(--color-text-primary); }\n\n/* ── UGC Promo Card ───────────────────────────────────── */\n.bp__promo {\n  margin-top: auto;\n  border-radius: 8px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  overflow: hidden;\n  position: relative;\n  transition: border-color 0.2s;\n}\n.bp__promo:hover {\n  border-color: color-mix(in srgb, var(--color-accent-base) 50%, var(--color-border-input));\n}\n.bp__promo::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(90deg, transparent, var(--color-accent-base, #d98f4f), var(--color-accent-strong, #e3a36a), var(--color-accent-base, #d98f4f), transparent);\n  z-index: 1;\n}\n\n.bp__promo-visual {\n  position: relative;\n  height: 100px;\n  background: linear-gradient(160deg, rgba(217,143,79,0.07) 0%, rgba(217,143,79,0.02) 100%);\n  overflow: hidden;\n}\n\n.bp__promo-chart-svg {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.bp__promo-platforms {\n  position: absolute;\n  top: 12px;\n  left: 14px;\n  display: flex;\n  gap: 8px;\n}\n\n.bp__promo-platform {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-text-secondary);\n  animation: bp-promo-float 3s ease-in-out infinite;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n}\n.bp__promo-platform--2 { animation-delay: 0.6s; }\n.bp__promo-platform--3 { animation-delay: 1.2s; }\n\n@keyframes bp-promo-float {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-3px); }\n}\n\n.bp__promo-stats {\n  position: absolute;\n  bottom: 10px;\n  right: 14px;\n  display: flex;\n  gap: 16px;\n}\n\n.bp__promo-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 1px;\n}\n\n.bp__promo-stat-val {\n  font-size: 14px;\n  font-weight: 700;\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  color: var(--color-accent-base, #d98f4f);\n}\n\n.bp__promo-stat-lbl {\n  font-size: 9px;\n  color: var(--color-text-secondary);\n  opacity: 0.6;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.bp__promo-body {\n  padding: 14px 16px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.bp__promo-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.bp__promo-logo {\n  height: 16px;\n  width: auto;\n  opacity: 0.85;\n}\n\n.bp__promo-label {\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  color: var(--color-accent-base, #d98f4f);\n}\n\n.bp__promo-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  line-height: 1.35;\n  margin: 0;\n}\n\n.bp__promo-desc {\n  font-size: 12px;\n  line-height: 1.55;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n.bp__promo-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 6px;\n  padding: 8px 16px;\n  border-radius: 5px;\n  background: var(--color-accent-base, #d98f4f);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: opacity 0.15s, transform 0.15s;\n  align-self: flex-start;\n}\n.bp__promo-cta:hover {\n  opacity: 0.88;\n  transform: translateX(2px);\n}\n\n/* ── Onboarding Modal ──────────────────────────────────── */\n.bp-ob {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  animation: bp-ob-fadeIn 0.3s ease;\n}\n\n@keyframes bp-ob-fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.bp-ob__card {\n  position: relative;\n  width: 480px;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 48px);\n  border-radius: 14px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-sidebar);\n  box-shadow:\n    0 0 0 1px rgba(255, 255, 255, 0.04),\n    0 24px 80px rgba(0, 0, 0, 0.55),\n    0 4px 16px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: bp-ob-slideUp 0.35s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes bp-ob-slideUp {\n  from { opacity: 0; transform: translateY(24px) scale(0.97); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n.bp-ob__close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 10;\n  width: 30px;\n  height: 30px;\n  border-radius: 6px;\n  border: none;\n  background: rgba(0, 0, 0, 0.3);\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s, color 0.15s;\n}\n.bp-ob__close:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: var(--color-text-primary);\n}\n\n/* Visuals area */\n.bp-ob__visual {\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.bp-ob__visual--welcome {\n  height: 200px;\n  background: radial-gradient(ellipse at 50% 80%, rgba(217,143,79,0.08) 0%, transparent 70%),\n              var(--color-bg-canvas-frame);\n}\n\n.bp-ob__visual--pipeline {\n  height: 180px;\n  padding: 0 24px;\n  background: radial-gradient(ellipse at 50% 50%, rgba(217,143,79,0.06) 0%, transparent 70%),\n              var(--color-bg-canvas-frame);\n}\n\n.bp-ob__visual--results {\n  height: 170px;\n  padding: 20px 24px;\n  background: radial-gradient(ellipse at 50% 50%, rgba(217,143,79,0.06) 0%, transparent 70%),\n              var(--color-bg-canvas-frame);\n}\n\n.bp-ob__hero-svg {\n  width: 320px;\n  height: 180px;\n}\n\n/* Pulse animation for brain hotspots */\n@keyframes bp-ob-pulse {\n  0%, 100% { r: 14; opacity: 0.7; }\n  50% { r: 18; opacity: 0.45; }\n}\n@keyframes bp-ob-pulse-sm {\n  0%, 100% { r: 10; opacity: 0.55; }\n  50% { r: 13; opacity: 0.35; }\n}\n\n.bp-ob__pulse {\n  animation: bp-ob-pulse 2.5s ease-in-out infinite;\n}\n.bp-ob__pulse--d1 {\n  animation: bp-ob-pulse-sm 2.5s ease-in-out 0.4s infinite;\n}\n.bp-ob__pulse--d2 {\n  animation: bp-ob-pulse-sm 2.5s ease-in-out 0.8s infinite;\n}\n.bp-ob__pulse--d3 {\n  animation: bp-ob-pulse-sm 2.5s ease-in-out 1.2s infinite;\n}\n\n/* Pipeline step visual */\n.bp-ob__pipeline {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.bp-ob__pipe-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  flex: 0 0 auto;\n}\n\n.bp-ob__pipe-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-text-secondary);\n  transition: all 0.3s;\n}\n\n.bp-ob__pipe-icon--accent {\n  border-color: color-mix(in srgb, var(--color-accent-base) 40%, var(--color-border-input));\n  color: var(--color-accent-base, #d98f4f);\n  box-shadow: 0 0 20px rgba(217, 143, 79, 0.1);\n}\n\n.bp-ob__pipe-icon--glow {\n  border-color: color-mix(in srgb, var(--color-accent-base) 50%, var(--color-border-input));\n  color: var(--color-accent-strong, #e3a36a);\n  box-shadow: 0 0 24px rgba(217, 143, 79, 0.15);\n  background: linear-gradient(135deg, var(--color-bg-canvas-surface), color-mix(in srgb, var(--color-accent-base) 8%, var(--color-bg-canvas-surface)));\n}\n\n.bp-ob__pipe-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  white-space: nowrap;\n}\n\n.bp-ob__pipe-sub {\n  font-size: 9px;\n  color: var(--color-text-secondary);\n  opacity: 0.65;\n  white-space: nowrap;\n  text-align: center;\n  max-width: 100px;\n}\n\n.bp-ob__pipe-arrow {\n  flex-shrink: 0;\n  opacity: 0.5;\n  margin-bottom: 24px;\n}\n\n/* Results grid */\n.bp-ob__results-row {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n}\n\n.bp-ob__result-card {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 14px 8px 10px;\n  border-radius: 10px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n}\n\n.bp-ob__result-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n}\n\n.bp-ob__result-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  text-align: center;\n}\n\n.bp-ob__result-hint {\n  font-size: 9px;\n  color: var(--color-text-secondary);\n  opacity: 0.6;\n  text-align: center;\n}\n\n/* Content */\n.bp-ob__content {\n  padding: 20px 28px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.bp-ob__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  letter-spacing: -0.3px;\n}\n\n.bp-ob__body {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.65;\n  color: var(--color-text-secondary);\n}\n\n/* Footer */\n.bp-ob__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 28px 20px;\n}\n\n.bp-ob__dots {\n  display: flex;\n  gap: 6px;\n}\n\n.bp-ob__dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  border: none;\n  padding: 0;\n  background: var(--color-border-input);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.bp-ob__dot--active {\n  background: var(--color-accent-base, #d98f4f);\n  box-shadow: 0 0 6px rgba(217, 143, 79, 0.4);\n  transform: scale(1.15);\n}\n.bp-ob__dot:hover:not(.bp-ob__dot--active) {\n  background: var(--color-text-secondary);\n}\n\n.bp-ob__actions {\n  display: flex;\n  gap: 8px;\n}\n\n.bp-ob__btn {\n  padding: 8px 20px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n  border: none;\n}\n\n.bp-ob__btn--primary {\n  background: var(--color-accent-base, #d98f4f);\n  color: #fff;\n}\n.bp-ob__btn--primary:hover {\n  opacity: 0.88;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(217, 143, 79, 0.3);\n}\n\n.bp-ob__btn--ghost {\n  background: transparent;\n  color: var(--color-text-secondary);\n  border: 1px solid var(--color-border-input);\n}\n.bp-ob__btn--ghost:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n/* ── Responsive ────────────────────────────────────────── */\n@media (max-width: 900px) {\n  .bp {\n    flex-direction: column;\n  }\n  .bp__left {\n    height: 45vh;\n    min-height: 300px;\n  }\n  .bp__right {\n    width: 100%;\n    min-width: 0;\n    border-left: none;\n    border-top: 1px solid var(--color-border-input);\n  }\n  .bp__examples-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n  .bp__ctrl-slider {\n    width: 120px;\n  }\n  .bp__promo-visual {\n    height: 80px;\n  }\n  .bp__promo-stats {\n    gap: 10px;\n  }\n}\n\n@media (max-width: 500px) {\n  .bp__right-scroll {\n    padding: 16px 14px;\n  }\n  .bp__examples-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 6px;\n  }\n  .bp__now-info {\n    display: none;\n  }\n  .bp-ob__card {\n    border-radius: 10px;\n  }\n  .bp-ob__content {\n    padding: 16px 20px 0;\n  }\n  .bp-ob__footer {\n    padding: 14px 20px 16px;\n  }\n  .bp-ob__visual--welcome,\n  .bp-ob__visual--pipeline,\n  .bp-ob__visual--results {\n    height: 150px;\n  }\n  .bp-ob__pipe-sub {\n    display: none;\n  }\n  .bp-ob__result-hint {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
